import { createSlice } from "@reduxjs/toolkit";

export type TrailerTypeCode = string;

export type TrailerTypeGroup = {
  id: number;
  code: string;
  name: string;
};

export type TrailerType = {
  id: number;
  code: TrailerTypeCode;
  name: string;
  group: TrailerTypeGroup;
};

type InitialState = {
  data: TrailerType[];
  isLoading: boolean;
};

const initialState: InitialState = {
  data: [],
  isLoading: false,
};

const trailerTypeSlice = createSlice({
  name: "trailerTypeSlice",
  initialState,
  reducers: {
    fetchData: (state) => {
      state.isLoading = true;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    reset: () => initialState,
  },
});

export default trailerTypeSlice;
